import React from 'react';
import './Body.css';
import {Link} from "react-router-dom"
import AdmissionForm from "../../Academics/photos/Admission Form.pdf"

const Body = () => {
  return (
    

    <div className='body-container1'>
       {/* <EnquiryForm></EnquiryForm> */}
      <div className='body-btn-section1'>
      
        <ul className='unorderlist'>
        <div data-aos="flip-right"> <li> <Link to="/Course"><button className='btn'>Course</button></Link></li> </div>
        <div data-aos="flip-right">  <li><a href={AdmissionForm} download="AdmissionForm"> <button className='btn'>Admission 2025</button></a></li></div>
      
        <div data-aos="flip-right"> <li><a href='/Contact'><button className='btn'>Apply Online</button></a></li></div>
        </ul>
        
      </div>
     
    </div>
   
  );
};

export default Body;
